"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PriceIntervals;
(function (PriceIntervals) {
    PriceIntervals[PriceIntervals["Daily"] = 1] = "Daily";
    PriceIntervals[PriceIntervals["Weekly"] = 2] = "Weekly";
    PriceIntervals[PriceIntervals["Monthly"] = 3] = "Monthly";
})(PriceIntervals || (PriceIntervals = {}));
exports.default = PriceIntervals;
